<template>
  <div class="column-block" :style="containerStyles">
    <div class="columns-container" :class="`columns-${columns}`">
      <div 
        v-for="(column, index) in columnData" 
        :key="index"
        class="column-item"
        :style="columnStyles"
      >
        <div class="column-content">
          <div v-if="column.content" v-html="column.content"></div>
          <div v-else class="column-placeholder">
            <i class="fas fa-plus"></i>
            <span>Agregar contenido</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColumnBlock',
  props: {
    columns: {
      type: Number,
      default: 2,
      validator: value => [2, 3, 4].includes(value)
    },
    content: {
      type: Array,
      default: () => []
    },
    gap: {
      type: String,
      default: '20px'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    padding: {
      type: String,
      default: '20px'
    }
  },
  computed: {
    containerStyles() {
      return {
        backgroundColor: this.backgroundColor,
        padding: this.padding
      }
    },
    columnStyles() {
      return {
        paddingLeft: `calc(${this.gap} / 2)`,
        paddingRight: `calc(${this.gap} / 2)`
      }
    },
    columnData() {
      const data = [...this.content]
      while (data.length < this.columns) {
        data.push({ content: '' })
      }
      return data.slice(0, this.columns)
    }
  }
}
</script>

<style scoped>
.column-block {
  width: 100%;
  margin: 10px 0;
}

.columns-container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.columns-2 .column-item {
  width: 50%;
}

.columns-3 .column-item {
  width: 33.333%;
}

.columns-4 .column-item {
  width: 25%;
}

.column-item {
  box-sizing: border-box;
  min-height: 100px;
}

.column-content {
  height: 100%;
  border: 2px dashed transparent;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.column-content:hover {
  border-color: #007bff;
}

.column-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.column-placeholder:hover {
  background: #e9ecef;
  color: #007bff;
}

.column-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
}

/* Responsive para emails */
@media only screen and (max-width: 600px) {
  .columns-container {
    display: block;
  }
  
  .column-item {
    width: 100% !important;
    margin-bottom: 20px;
  }
  
  .column-item:last-child {
    margin-bottom: 0;
  }
}
</style> 